import { render, staticRenderFns } from "./FlatForm.vue?vue&type=template&id=7f2e59ba&scoped=true&"
import script from "./FlatForm.vue?vue&type=script&lang=js&"
export * from "./FlatForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e59ba",
  null
  
)

export default component.exports